import MainLayout from "@/components/layout/MainLayout.vue";
import { required, helpers } from "vuelidate/lib/validators";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import store from "@/store";
import axios from "axios";

const phoneOrAccountFormat = helpers.withParams(
  { type: 'phoneOrAccountFormat' },
  value => {
    if (!value) return false;
    const regex = /^((\+?95|0)?(9\d{7,9}|1\d{5,7})|(T|S|SC)\d{6,})$/;
    return regex.test(value);
  }
);

export default {
    name: "login",

    components: {
        MainLayout,
        Loading,
    },

    data() {
        return {
            submitted: false,
            showAlert: false,
            loginForm: {
                user_type: '',
                phone_number: this.$route.query.phone || "",
                password: this.password,
            },
            isConnected: false,
            name: "",
            email: "",
            personalID: "",
            picture: "",
            FB: "",
            type_radio: "",
            disabled: false,
            isLoading: false,
        };
    },

    validations: {
        loginForm: {
            user_type: {
                required
            },
            phone_number: {
                required,
                phoneOrAccountFormat
            },
            password: {
                required
            },
        },
    },

    methods: {
        submitLogin() {
            this.submitted = true;
            if (this.$v.loginForm.$invalid) {
                console.log(this.$v.loginForm);
                console.log("login error");
            } else {
                this.login();
            }
        },
        
        login() {
            this.isLoading = true;
            this.disabled = true;
            this.$store
                .dispatch("login", {
                    phone_number: this.loginForm.phone_number,
                    password: this.loginForm.password,
                    user_type: this.loginForm.user_type,
                })
                .then(() => {
                    if (this.$store.state.user['token']) {
                        window.location.replace('/');
                    } else {
                        this.isLoading = false;
                        this.disabled = false;
                        this.$notification.error("စကားဝှက် မှားယွင်းနေပါသည်", {
                            timer: 3,
                            position: 'bottomCenter'
                        });
                    }
                })
                .catch(error => {
                    this.isLoading = false;
                    this.disabled = false;
                    console.log(error);
                    const errorMsg = error.response?.data?.error || "အကောင့်မရှိပါ";
                    this.$notification.error(errorMsg, {
                        timer: 3,
                        position: "bottomCenter",
                    });
                });
        },

        AuthProvider(provider) {
            this.$auth
                .authenticate(provider)
                .then((response) => {
                    this.facebookLogin(provider, response);
                })
                .catch((err) => {
                    console.log({
                        err: err
                    });
                });
        },

        facebookLogin(provider, response) {
            axios.post("/vuefacebooklogin/" + provider, response)
                .then((response) => {
                    if (response.data.token) {
                        store.commit("setUserData", response.data);
                        this.$router.push({
                            name: 'home'
                        });
                        location.reload();
                    } else {               
                        store.commit("setUserData", response.data);
                        this.showAlert = true;
                    }
                })
                .catch(() => {
                    this.$notification.error("Login Failed", {
                        timer: 3,
                        position: 'bottomCenter'
                    });
                });
        },

        submitAlert() {
            if (this.type_radio == 2) {
                this.$router.push({
                    name: "SignupTeaFB",
                });
            } else {
                this.$router.push({
                    name: "SignupStuFB",
                });
            }
        },
    },

    mounted() {
        this.loginForm.phone_number = localStorage.getItem('phoneNo');
    }
};
